var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="company--table '+
((__t=( p_name ))==null?'':__t)+
'"> <h2> <a id="'+
((__t=( item.id ))==null?'':__t)+
'"></a> '+
((__t=( item.name ))==null?'':__t)+
' <span class="percent">'+
((__t=( score ))==null?'':__t)+
'</span> </h2> <div class="overflow-for-table"> <table> <thead> <tr> <th class="cell--first">'+
((__t=( name ))==null?'':__t)+
'</th> ';
 item.headers.forEach(function(item) { 
__p+=' <th>'+
((__t=( item.text ))==null?'':__t)+
'</th> ';
 }); 
__p+=' </tr> </thead> <tbody> ';
 item.rows.forEach(function(row) { 
__p+=' <tr> ';
 row.cells.forEach(function(data) { 
__p+=' <td>'+
((__t=( data.value ))==null?'':__t)+
'</td> ';
 }); 
__p+=' </tr> ';
 }); 
__p+=' </tbody> <tfoot> <tr> <td>Average score</td> ';
 item.average.forEach(function(item) { 
__p+=' ';
 if (item.value == 'N/A') { 
__p+=' <td>N/A</td> ';
 } else { 
__p+=' <td>'+
((__t=( Math.round(item.value*100)/100 ))==null?'':__t)+
'</td> ';
 } 
__p+=' ';
 }); 
__p+=' </tr> </tfoot> </table> </div> </section>';
}
return __p;
};
